// @flow

// Libs
import React from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'

// Utils
import getUrl from 'hfty-utils/url'
import ArrowForward from 'fc-icons/src/ArrowForward'

// Constants
import {
  LAB_RESULT,
  MAP_REPORT,
  LAB_REPORT,
  PRESCRIPTION,
  RECOMMENDATION,
  OTHER,
  LAB_ANALYSIS_MAP,
  SOIL_RESULTS_SHAPEFILE_URL,
} from '../../constants'

// Components
import Loader from '../Loader'
import Button from '@react-mdc/button'

// Images
import pdfImage from 'hfty-images/src/pdf.png'
import DownloadIcon from 'fc-icons/src/Download'

// Style
import { styles as s } from './style'
import { white } from 'hfty-styles/src/colors'
import './media.scss'

export default class Layout extends React.Component {
  props: {
    history: Object,
    match: Object,
    jobs: Array,
    reports: Array,
    reportsIsLoading: boolean,
    errors: string,
    token: string,
    subHeader: string,
    actions: {
      _redirect: Function,
      loadLabResults: Function,
      loadMapReports: Function,
      downloadZip: Function,
    },
  }

  componentWillMount () {
    const { resultsType } = this.props.match.params

    if (resultsType === LAB_RESULT) {
      if (this.props.jobs.length === 0) {
        this.props.actions._redirect('/')
      }
    }
  }

  componentDidMount () {
    this.loadReports()
  }

  renderHeader = (): React.Element<any> => {
    const { resultsType, id } = this.props.match.params
    const isPageLabResults = resultsType === LAB_RESULT

    return (
      <div>
        <div style={s.headerWrapper}>
          <h1 style={s.h1}>
            { isPageLabResults ? `Lab Results - ${id}` : 'Map Reports' }
          </h1>
          <Button
            style={{...s.btn, ...s.secondaryBtn}}
            raised
            onClick={(): Function => this.props.history.goBack()}
          >
            <ArrowForward
              style={{...s.icon, ...s.backButtonIcon}}
              color={white()}
              size={14}
            />
            Back
          </Button>
        </div>
        {isPageLabResults
          ? (
            <div>
              <h2 style={s.h2}>{this.props.subHeader}</h2>
              <div style={s.btnsHolder} className='reports-btns-holder'>
                <Button
                  raised
                  primary
                  style={s.btn}
                  className='soil-results-btn'
                  onClick={() => {
                    this.props.actions.downloadZip({
                      path: SOIL_RESULTS_SHAPEFILE_URL,
                      queryParams: {
                        job: id,
                      },
                      fileName: `Grid_Points_${id}`,
                      errorItem: 'Grid Points',
                    })
                  }}
                >
                  <DownloadIcon
                    size={18}
                    color={white()}
                    style={s.icon}
                  />
                  {` Soil Results - Shapefile`}
                </Button>
                <Button
                  raised
                  primary
                  style={s.btn}
                >
                  <Link
                    to={`/map/jobs/${id}`}
                    onClick={(event: Object) => {
                      event.stopPropagation()
                    }}
                    style={s.link}
                  >
                    View map results
                  </Link>
                </Button>
              </div>
            </div>
          )
          : null
        }
      </div>
    )
  }

  renderContent = (): React.Element<any> => {
    const { reportsIsLoading, reports, token } = this.props

    return (
      <div style={s.content}>
        { !reportsIsLoading ? this.renderReports(reports, token) : <Loader /> }
      </div>
    )
  }

  renderErrors = (): React.Element<any> => {
    const { errors } = this.props

    if (errors) {
      return (
        <div style={s.errorsWrapper}>
          <span style={s.errorMessage}>
            { errors }
          </span>
        </div>
      )
    }
  }

  loadReports = () => {
    const { resultsType, id } = this.props.match.params
    const { loadMapReports, loadLabResults } = this.props.actions
    const { field } = this.props.jobs.find((job: Object): Object => job.id === parseInt(id)) || ''

    switch (resultsType) {
      case LAB_RESULT:
        loadLabResults(field)
        break

      case MAP_REPORT:
        loadMapReports(id)
        break
    }
  }

  applyFilters = (reports: Array): Array => {
    const { resultsType } = this.props.match.params
    const labResultsFilter = (type: string): boolean => (
      type === LAB_REPORT ||
      type === OTHER ||
      type === LAB_ANALYSIS_MAP
    )
    const mapReportsFilter = (type: string): boolean => (
      type === PRESCRIPTION ||
      type === RECOMMENDATION
    )

    if (resultsType === LAB_RESULT) {
      return reports.filter((report: Object): Array => labResultsFilter(report.type))
    } else if (resultsType === MAP_REPORT) {
      return reports.filter((report: Object): Array => mapReportsFilter(report.type))
    }
  }

  renderReports = (reports: Array, token: string): React.Element<any> => {
    const renderPdf = (data: Object, key: number): React.Element<any> => {
      const getLabel = (label: string): string => {
        if (label) {
          const fragments = label.split('-')
          return fragments[fragments.length - 1]
        }
      }

      const pdfLink = getUrl({
        path: `blobstore/${data.blob}`,
        excludeTrailingSlash: true,
        token: token,
      })

      return (
        <div key={key} style={s.pdfComponentWrapper}>
          <div style={s.pdfImage}>
            <a target='_blank' href={pdfLink}>
              <img style={s.pdfImg} src={pdfImage} />
            </a>
          </div>
          <div style={s.pdfContent}>
            <div>
              <span style={s.pdfContentLabel}>
                { getLabel(data.label) }
              </span>
            </div>
            <span style={s.pdfContentType}>
              { data.type }
            </span>
            <span style={s.pdfContentDate}>
              { moment(data.created_date).format('MM/DD/YY') }
            </span>
          </div>
        </div>
      )
    }

    return this.applyFilters(reports).map(renderPdf)
  }

  render (): React.Element<any> {
    return (
      <div style={s.outerWrapper}>
        { this.renderHeader() }
        { this.renderContent() }
        { this.renderErrors() }
      </div>
    )
  }
}
